import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useCanjeModal } from '../context/CanjeModalContext';

const CanjeModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useCanjeModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('ExchangeOperation')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default CanjeModalHeader;
